import { CircularProgress } from '@tino-frontend/coreui'
import { useEffect } from 'react'

import { LoadersRoot } from './loaders.styles'
import { BrandMark } from '@tino-frontend/logos'

export type PageLoaderProps = {
  brand?: boolean
  onUnmounted?: () => void
}

export function PageLoader({ brand, onUnmounted }: PageLoaderProps) {
  useEffect(() => {
    return () => {
      onUnmounted && onUnmounted()
    }
  }, [])

  return (
    <LoadersRoot bgcolor={'background.paper'}>
      {brand ? (
        <BrandMark variant="negative" type="symbol" sx={{ width: 50 }} />
      ) : (
        <CircularProgress color="secondary" />
      )}
    </LoadersRoot>
  )
}
